import { Form, Input } from "antd";
import React, { useState } from "react";
import "./allergiesandmedication.css";
import Dropdown from "../../../DropDown/Dropdown";
import {
  MEDICINE_REDUX_STATE,
  allergyStatusOptions,
  sinceOptions,
  statusOptions,
} from "../../../../Helpers/InterBranchConstants";

function AllergiesandMedicationPatient({ setActiveTop }) {
  //Constants...............................................................................
  const empty_medication = {
    index: 0,
    medication: "",
    quantity: "",
    frequency: "",
    status: "",
    fileURL: "",
  };

  const empty_allergie = {
    index: 0,
    Allergent: "",
    Reaction: "",
    Since: "",
  };
  //...........................................................................................

  //States...............................................................................
  const [dataForm, setDataForm] = useState({
    allergies: [],
    medications: [],
  });

  //Main Functions ....................................................................
  function addNewAllergie() {
    let _id = 0;
    if (dataForm?.allergies || dataForm?.allergies.length) {
      _id = incrementIndex(dataForm?.allergies.at(-1)?.index);
    }

    setDataForm((prev) => {
      return {
        ...prev,
        allergies: [...prev.allergies, { ...empty_allergie, index: _id }],
      };
    });
  }
  function addNewMedicine() {
    let _id = 0;
    if (dataForm?.medications || dataForm?.medications.length) {
      _id = incrementIndex(dataForm?.medications.at(-1)?.index);
    }

    setDataForm((prev) => {
      return {
        ...prev,
        medications: [...prev.medications, { ...empty_medication, index: _id }],
      };
    });
  }
  let _removeAllergie = (index, name) => {
    const _data = dataForm?.allergies?.filter((each) => each.index != index);
    setDataForm((prev) => {
      return {
        ...prev,
        allergies: _data,
      };
    });
  };
  let _removeMedicine = (index, name) => {
    const _data = dataForm?.medications?.filter((each) => each.index != index);
    setDataForm((prev) => {
      return {
        ...prev,
        medications: _data,
      };
    });
  };

  const updateTable = (value, item, dataKey, index) => {
    if (item === "allergies") {
      let updatedData = dataForm?.allergies.map((eachAllergy, key) => {
        if (eachAllergy.index === index) {
          eachAllergy[dataKey] = value;
        }
        return eachAllergy;
      });

      setDataForm((prev) => {
        return {
          ...prev,
          allergies: updatedData,
        };
      });
    }

    if (item === "medications") {
      let updatedData = dataForm?.medications.map((eachMedication, key) => {
        if (eachMedication.index === index) {
          eachMedication[dataKey] = value;
        }
        return eachMedication;
      });

      setDataForm((prev) => {
        return {
          ...prev,
          medications: updatedData,
        };
      });
    }
  };

  function handleSaveButtonClick() {
    //All local changes will be available here. If we need to preload data, load the data to the local state.
    //  !!!Important  All the local changes will clear when component unmont
    console.log({
      dataForm,
    });
  }
  //...........................................................................................

  //Not using Functions (Maybe usable in future) ....................................................................
  const onFinishAllergies = (values) => {};
  const onFinishFailedAllergies = (error) => {};

  const onFinishMedication = (values) => {};
  const onFinishFailedMedication = (error) => {};
  //...........................................................................................

  //Suppoting function Functions ....................................................................
  function allowOnlyNumericsOrDigits(e) {
    if (e.target.value.includes(".") && e.key == ".") {
      e.preventDefault();
    }

    ![
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ".",
      "Backspace",
    ].includes(e.key) && e.preventDefault();
  }

  let validateAlphaNumericsOnly = (event) => {
    if (!event.key.match(new RegExp("^[a-zA-Z0-9_ ]*$"))) {
      event.preventDefault();
    }
  };

  const incrementIndex = (value) => {
    if (value === 0 || value) {
      return value + 1;
    } else {
      return 0;
    }
  };
  //...........................................................................................

  return (
    <>
      <div>
        <div className="sub-container-row">
          <Form
            name="allergyForm"
            onFinish={onFinishAllergies}
            onFinishFailed={onFinishFailedAllergies}
            autoComplete="off"
            preserve={false}
          >
            <div className="am-table-container">
              <div className="table-header">
                <span>Allergies</span>

                <button
                  onClick={addNewAllergie}
                  type="submit"
                  className="add-allergy-button"
                >
                  <img
                    src={require("../../../../assets/InterBranch/PNGIcons/more.png")}
                    alt=""
                  />
                </button>
              </div>

              <table>
                <tr>
                  <th>Allergen</th>
                  <th>Reaction</th>
                  <th>Status</th>
                  <th></th>
                </tr>

                <tbody>
                  {dataForm?.allergies && dataForm?.allergies.length ? (
                    dataForm?.allergies.map((element, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            <Form.Item
                              name={`Allergent${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter allergen",
                                },
                              ]}
                              initialValue={
                                element.Allergent
                                  ? element.Allergent
                                  : undefined
                              }
                            >
                              <Input
                                className="reaction"
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "allergies",
                                    "Allergent",
                                    element.index
                                  );
                                }}
                                value={
                                  element.Allergent
                                    ? element.Allergent
                                    : undefined
                                }
                                width={"100%"}
                                placeholder="Allergen"
                                onKeyDown={validateAlphaNumericsOnly}
                                maxLength={25}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Reaction${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter reaction",
                                },
                              ]}
                              // defaultValue={element.Reaction}
                              initialValue={element.Reaction}
                            >
                              <Input
                                className="reaction"
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "allergies",
                                    "Reaction",
                                    element.index
                                  );
                                }}
                                value={element.Reaction}
                                width={"100%"}
                                placeholder="Reaction"
                                maxLength={200}
                                onKeyDown={validateAlphaNumericsOnly}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Since${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select status",
                                },
                              ]}
                              // defaultValue={element.Since}
                              initialValue={element.Since}
                            >
                              <Dropdown
                                name="Since"
                                id="allergies"
                                index={element.index}
                                data={allergyStatusOptions}
                                onChange={updateTable}
                                width={"100%"}
                                placeholder="Select"
                                isV2
                                value={element.Since}
                              />
                            </Form.Item>
                          </td>

                          <td>
                            <img
                              onClick={() => {
                                _removeAllergie(
                                  element.index,
                                  element.Allergent ? element.Allergent : null
                                );
                              }}
                              style={{ cursor: "pointer" }}
                              src={require("../../../../assets/InterBranch/PNGIcons/delete.png")}
                              alt=""
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <div className="no-data">
                          <img
                            src={require("../../../../assets/InterBranch/PNGIcons/no_allergies.png")}
                            alt=""
                          />

                          <span>No data available</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Form>

          <Form
            name="medicationForm"
            onFinish={onFinishMedication}
            onFinishFailed={onFinishFailedMedication}
            autoComplete="off"
            preserve={false}
          >
            <div className="am-table-container">
              <div className="table-header">
                <span>Medication</span>

                <button
                  onClick={addNewMedicine}
                  type="submit"
                  className="add-allergy-button"
                >
                  <img
                    src={require("../../../../assets/InterBranch/PNGIcons/more.png")}
                    alt=""
                  />
                </button>
              </div>

              <table>
                <tr>
                  <th>Medicine Name</th>
                  <th>Quantity</th>
                  <th>Frequency</th>
                  <th colSpan={2}>Status</th>
                </tr>

                <tbody>
                  {dataForm?.medications && dataForm?.medications.length ? (
                    dataForm?.medications.map((element, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            <Form.Item
                              name={`Name${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter medicine name",
                                },
                              ]}
                              // defaultValue={element.Name}
                              initialValue={element.Name}
                            >
                              <Input
                                className="reaction"
                                maxLength={30}
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "medications",
                                    "Name",
                                    element.index
                                  );
                                }}
                                value={element.Name}
                                width={"100%"}
                                placeholder="Name"
                                onKeyDown={validateAlphaNumericsOnly}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Quantity${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter quantity",
                                },
                              ]}
                              // defaultValue={element.Quantity}
                              initialValue={element.Quantity}
                            >
                              <Input
                                maxLength={4}
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "medications",
                                    "Quantity",
                                    element.index
                                  );
                                }}
                                // onChange={(e) => { updateTable({ from: MEDICINE_REDUX_STATE, index: key, key: "Quantity", value: e.target.value }) }}
                                value={element.Quantity}
                                width={"100%"}
                                className="reaction"
                                onKeyDown={allowOnlyNumericsOrDigits}
                                placeholder="Quantity"
                              />
                            </Form.Item>
                          </td>

                          <td>
                            <Form.Item
                              name={`Since${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select frequency",
                                },
                              ]}
                              // defaultValue={element.Since}
                              initialValue={element.Since}
                            >
                              <Dropdown
                                name="Since"
                                id="medications"
                                index={element.index}
                                data={sinceOptions}
                                options={{
                                  from: MEDICINE_REDUX_STATE,
                                  index: key,
                                  key: "Since",
                                }}
                                onChange={updateTable}
                                width={300}
                                placeholder="Select"
                                isV2
                                value={element.Since}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Status${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select status",
                                },
                              ]}
                              // defaultValue={element.Status}
                              initialValue={element.Status}
                            >
                              <Dropdown
                                name="Status"
                                id="medications"
                                index={element.index}
                                data={statusOptions}
                                options={{
                                  from: MEDICINE_REDUX_STATE,
                                  index: key,
                                  key: "Status",
                                }}
                                onChange={updateTable}
                                width={190}
                                placeholder="Select"
                                isV2
                                value={element.Status}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                _removeMedicine(
                                  element.index,
                                  element.Name ? element.Name : "Medicine"
                                );
                              }}
                              src={require("../../../../assets/InterBranch/PNGIcons/delete.png")}
                              alt=""
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <div className="no-data">
                          <img
                            src={require("../../../../assets/InterBranch/PNGIcons/no_medicines.png")}
                            alt=""
                          />

                          <span>No data available</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Form>
        </div>
      </div>

      <div className="button-container">
        <button className="submt-btn" onClick={handleSaveButtonClick}>
          SAVE
        </button>

        {/* {
                    isScheduled() &&
                    <button className='join-btn' onClick={bookappointment}>BOOK APPOINTMENT</button>
                    // :
                    // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                } */}
      </div>
    </>
  );
}

export default AllergiesandMedicationPatient;
